export default __webpack_public_path__ + "static/media/slide3.ef3d660a.jpg";